import React, { useState, useEffect } from "react";
import { Card, CardBody, Col, Button, Spinner, Row, Input } from "reactstrap";
import DataTable from "react-data-table-component";
import { AgentTitle, CallHistoryTitle } from "../../../Utils/Constants";
import Breadcrumbs from "../../../CommonElements/Breadcrumbs";
import axios from "axios";
import useCurrency, { baseUrl, mediaUrl } from "../../../Utils/FileUpload";
import FilterComponent from "../../../Components/Tables/DataTables/Common/FilterComponent";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";
import moment from "moment";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
interface CallHistory {
  id: number;
  call_date: string; // format: YYYY-MM-DD
  start_time: string; // format: HH:mm:ss
  end_time: string; // format: HH:mm:ss
  customer_mobile: string;
  duration: number; // Duration in minutes
  agent_name: string;
  customer_id: string;
  agent_id: string;
  agent_amount: string;
  file: string;
}
export default function CallHistory() {
  const [filterText, setFilterText] = useState("");
  const [filteredItems, setFilteredItems] = useState<CallHistory[]>([]);
  const [loading, setLoading] = useState(true);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [perPage, setPerPage] = useState<number>(10);
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [fromDate, setFromDate] = useState<Date | null>(null);
  const [toDate, setToDate] = useState<Date | null>(null);
  const token = localStorage.getItem("token");
  const { currency } = useCurrency();
  const location = useLocation();
  const agentId = location?.state?.agent_id || null;
  const customerId = location?.state?.customer_id || null;
  const customerName = location?.state?.customer_name || null;
  const customerMobile = location?.state?.customer_mobile || null;
  // console.log(agentId)
  let personTitle = "";

  if (agentId && filteredItems.length > 0) {
    personTitle = `${filteredItems[0].agent_name || "Agent"}'s Call History`;
  } else if (customerId) {
    const displayName = customerName || customerMobile || "Customer";
    personTitle = `${displayName}'s Call History`;
  }

  const fetchData = async (page = 1, perPage = 10, search = "") => {
    setLoading(true);
    try {
      const response = await axios.get(`${baseUrl}call_history/getall`, {
        params: {
          page,
          per_page: perPage,
          search: search.trim() !== "" ? search : undefined,
          agent_id: agentId || undefined,
          customer_id: customerId || undefined,
          from_date: fromDate ? fromDate.toISOString().split("T")[0] : null,
          to_date: toDate ? toDate.toISOString().split("T")[0] : null,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      let data: CallHistory[] = response.data.data;
      // If agentId exists, filter by agent.id
      if (agentId) {
        data = data.filter((item) => item.agent_id === agentId);
        console.log(data, "data");
      }
      // If customerId exists, filter by customer.id
      if (customerId) {
        data = data.filter((item) => item.customer_id === customerId);
        console.log(data, "data");
      }
      console.log(data, "data");

      setFilteredItems(data);
      setTotalRows(response.data.total);
      setCurrentPage(response.data.current_page);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  // Debounce search term
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(filterText);
      setCurrentPage(1);
    }, 500);
    return () => clearTimeout(handler);
  }, [filterText]);

  useEffect(() => {
    fetchData(currentPage, perPage, debouncedSearchTerm);
  }, [currentPage, perPage, debouncedSearchTerm, fromDate, toDate]);

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
  };

  const handlePerRowsChange = async (newPerPage: number, page: number) => {
    setPerPage(newPerPage);
    setCurrentPage(1);
  };

  // Define columns with actions dynamically based on agentId and customerId
  const getCallHistoryColumns = () => {
    const columns = [
      {
        name: "S.No",
        cell: (row: CallHistory, index: number) => (
          <>{(currentPage - 1) * perPage + index + 1}</>
        ),
        width: "10%"
      },
    ];

    if (!customerId) {
      columns.push({
        name: "Customer Mobile",
        cell: (row: CallHistory) => <>{row.customer_mobile || "N/A"}</>,
        width: "20%"

      });
    }

    if (!agentId) {
      columns.push({
        name: "Agent Name",
        cell: (row: CallHistory) => <>{row.agent_name || "N/A"}</>,
        width: "30%"

      });
    }

    columns.push(
      {
        name: "Call Date",
        cell: (row: CallHistory) => {
          const startFormatted = moment(row.start_time, "HH:mm:ss").format(
            "hh:mmA"
          );
          const endFormatted = moment(row.end_time, "HH:mm:ss").format(
            "hh:mmA"
          );
          return <>{`${row.call_date} ${startFormatted} - ${endFormatted}`}</>;
        },
        width: "30%"

      },
      {
        name: "Duration",
        cell: (row: CallHistory) => {
          const start = new Date(`1970-01-01T${row.start_time}`);
          const end = new Date(`1970-01-01T${row.end_time}`);
          const diff = Math.floor((end.getTime() - start.getTime()) / 60000);
          return <>{`${diff} mins`}</>;
        },
        width: "20%"
      },
      // {
      //   name: "Recording",
      //   cell: (row: CallHistory) => {
      //     if (!row.file) return <span>N/A</span>;

      //     const fileUrl = `${mediaUrl}/${row.file}`;
      //     const ext = row.file.split(".").pop()?.toLowerCase();
      //     const mimeType = `audio/${ext === "mp3" ? "mpeg" : ext}`; // Handle MP3 special case

      //     return (
      //       <audio
      //         controls
      //         preload="none"
      //         key={`audio-${row.id}`}
      //         onError={(e) => console.error("Audio error:", e)}
      //       >
      //         <source src={fileUrl} type={mimeType} />
      //         Your browser does not support audio.
      //       </audio>
      //     );
      //   },
      // }
    );

    // Add agent amount column if agentId is present
    if (agentId) {
      columns.push({
        name: `Agent Amount ${currency ? `(${currency})` : ""}`,
        cell: (row: CallHistory) => <>{row.agent_amount || "N/A"}</>,
        width: "20%"

      });
    }

    return columns;
  };


  const customStyles = {
    headCells: {
      style: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#308e87",
        backgroundColor: "#f8f9fa",
        borderBottom: "2px solid #308e87",
      },
    },
    rows: {
      style: {
        borderBottom: "1px solid #dee2e6",
      },
    },
    table: {
      style: {
        border: "1px solid #dee2e6",
        borderRadius: "8px",
      },
    },
  };

  return (
    <>
      <Breadcrumbs
        pageTitle={CallHistoryTitle}
        parent={AgentTitle}
        title={CallHistoryTitle}
      />
      <Col xl={12} className="mb-lg-3">
        <Card>
          <CardBody>
            {personTitle && (
              <h5
                style={{
                  marginBottom: "1rem",
                  color: "#308e87",
                  fontWeight: "600",
                }}
              >
                {personTitle}
              </h5>
            )}
            <Row className="align-items-center justify-content-end mb-3">
              <Col xl={4}>
                {/* Conditionally show date filter contents, but keep the column space */}
                {agentId && (
                  <div className="d-flex align-items-center gap-2">
                    <label className="mb-0">From:</label>
                    <div style={{ flex: 1 }}>
                      <DatePicker
                        selected={fromDate}
                        onChange={(date: Date | null) => setFromDate(date)}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        placeholderText="Start date"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        wrapperClassName="datePicker"
                      />
                    </div>

                    <label className="mb-0">To:</label>
                    <div style={{ flex: 1 }}>
                      <DatePicker
                        selected={toDate}
                        onChange={(date: Date | null) => setToDate(date)}
                        dateFormat="yyyy-MM-dd"
                        className="form-control"
                        placeholderText="End date"
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                      />
                    </div>
                  </div>
                )}
              </Col>

              <Col xl={3}>
                <div className=" d-flex align-items-center">
                  <Input
                    type="text"
                    placeholder="Search"
                    value={filterText}
                    onChange={(e) => setFilterText(e.target.value)}
                    className="me-2"
                  />
                </div>
              </Col>
            </Row>

            <div className="table-responsive custom-scrollbar">
              <DataTable
                data={filteredItems}
                // columns={callHistoryTableColumns}
                columns={getCallHistoryColumns()}
                highlightOnHover
                striped
                customStyles={customStyles}
                pagination
                paginationServer
                paginationPerPage={perPage}
                paginationTotalRows={totalRows}
                onChangePage={handlePageChange}
                onChangeRowsPerPage={handlePerRowsChange}
                paginationDefaultPage={currentPage}
                progressPending={loading}
                progressComponent={
                  <div className="p-5">
                    <Spinner color="primary" />
                  </div>
                }
                responsive
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <ToastContainer />
    </>
  );
}
